export default __webpack_public_path__ + "static/media/Licensed Key (1).6c5fe2ca.svg";